import { Reducer } from 'redux';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { STATE } from 'app/constants';
import {
  ACTION, RequestLoadDefaultValues, ReceiveLoadDefaultValues, FailLoadDefaultValues,
  RequestSaveDefaultValues, ReceiveSaveDefaultValues, FailDefaultValuesExecute,
  ClearValidation, RequestRole, ReceiveRole, FailRole,
  UpdateAccessData, RequestRolePanelAccess, ReceiveRolePanelAccess, FailRolePanelAccess,
  ClearDefaultValuesData
} from './action-types';
import { UserDefaultValuesState } from './types';
import { AccessItem } from 'app/components/access-panel/shared/types';
import { clearValidation } from 'app/components/access-panel/validation/validation-messages';

export const INITIAL_USER_DEFAULT_VALUES_STATE: UserDefaultValuesState = {
  data: undefined,
  role: undefined,
  rolePanelAccess: false,
  accessData: {},
  validation: {},
  fetchingLoadDefaultValues: false,
  fetchingSaveDefaultValues: false,
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<UserDefaultValuesState> } = {
  [ACTION.CLEAR_DEFAULT_VALUES_DATA]: (state: UserDefaultValuesState, action: RequestLoadDefaultValues): UserDefaultValuesState => {
    return INITIAL_USER_DEFAULT_VALUES_STATE;
  },

  [ACTION.REQUEST_LOAD_DEFAULT_VALUES]: (state: UserDefaultValuesState, action: RequestLoadDefaultValues): UserDefaultValuesState => {
    return {
      ...state,
      fetchingLoadDefaultValues: true,
      data: undefined
    };
  },

  [ACTION.RECEIVE_LOAD_DEFAULT_VALUES]: (state: UserDefaultValuesState, action: ReceiveLoadDefaultValues): UserDefaultValuesState => {
    const { defaultValues } = action.data as any;
    return {
      ...state,
      fetchingLoadDefaultValues: false,
      data: { defaultValues }
    };
  },

  [ACTION.FAIL_LOAD_DEFAULT_VALUES]: (state: UserDefaultValuesState, action: FailLoadDefaultValues): UserDefaultValuesState => {
    return {
      ...state,
      fetchingLoadDefaultValues: false
    };
  },

  [ACTION.REQUEST_SAVE_DEFAULT_VALUES]: (state: UserDefaultValuesState, action: RequestSaveDefaultValues): UserDefaultValuesState => {
    return {
      ...state,
      fetchingSaveDefaultValues: true
    };
  },

  [ACTION.RECEIVE_SAVE_DEFAULT_VALUES]: (state: UserDefaultValuesState, action: ReceiveSaveDefaultValues): UserDefaultValuesState => {
    return {
      ...state,
      fetchingSaveDefaultValues: false
    };
  },

  [ACTION.FAIL_DEFAULT_VALUES_EXECUTE]: (state: UserDefaultValuesState, action: FailDefaultValuesExecute): UserDefaultValuesState => {
    return {
      ...state,
      fetchingSaveDefaultValues: false
    };
  },

  [ACTION.PROCESS_DEFAULT_VALUES_FAILED]: (state: UserDefaultValuesState, action: any): UserDefaultValuesState => {
    return {
      ...state,
      validation: { ...action.errors },
      fetchingLoadDefaultValues: false
    };
  },

  [ACTION.CLEAR_VALIDATION]: (state: UserDefaultValuesState, action: ClearValidation): UserDefaultValuesState => {
    return {
      ...state,
      validation: clearValidation(state.validation, action.formName, action.parameters)
    };
  },

  [ACTION.REQUEST_ROLE]: (state: UserDefaultValuesState, action: RequestRole): UserDefaultValuesState => {
    return {
      ...state,
      role: {
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_ROLE]: (state: UserDefaultValuesState, action: ReceiveRole): UserDefaultValuesState => {

    return {
      ...state,
      role: {
        fetching: false,
        data: action.data
      }
    };
  },

  [ACTION.FAIL_ROLE]: (state: UserDefaultValuesState, action: FailRole): UserDefaultValuesState => {

    return {
      ...state,
      role: {
        fetching: false
      }
    };
  },

  [ACTION.UPDATE_ACCESS_DATA]: (state: UserDefaultValuesState, action: UpdateAccessData): UserDefaultValuesState => {

    const accessData = state.accessData || {};
    const accessItem = accessData[action.key] || {} as AccessItem;

    return {
      ...state,
      accessData: {
        ...accessData,
        [action.key]: {
          ...accessItem,
          ...action.accessItem
        }
      }
    };
  },
  [ACTION.REQUEST_ROLE_PANEL_ACCESS]: (state: UserDefaultValuesState, action: RequestRolePanelAccess): UserDefaultValuesState => {
    return {
      ...state,
      rolePanelAccess: false
    };
  },
  [ACTION.RECEIVE_ROLE_PANEL_ACCESS]: (state: UserDefaultValuesState, action: ReceiveRolePanelAccess): UserDefaultValuesState => {
    return {
      ...state,
      rolePanelAccess: !!action.values.length
    };
  },
  [ACTION.FAIL_ROLE_PANEL_ACCESS]: (state: UserDefaultValuesState, action: FailRolePanelAccess): UserDefaultValuesState => {
    return {
      ...state,
      rolePanelAccess: false
    };
  },

  [ACTION.CLEAR_DEFAULT_VALUES_DATA]: (state: UserDefaultValuesState, action: ClearDefaultValuesData): UserDefaultValuesState => {
    return {
      ...state,
      data: undefined,
      accessData: {}
    };
  }
};

export const reducer: Reducer<UserDefaultValuesState> =
  (state: UserDefaultValuesState = INITIAL_USER_DEFAULT_VALUES_STATE, action: any) => {
    const r = reducers[action.type];
    return (r && r(state, action)) || simpleFormReducer(STATE.userDefaultValues)(state, action);
  };
